import React, { Component } from 'react';
import Markdown from 'react-markdown';
import './ProjectBlock.css';
import FontAwesome from 'react-fontawesome';
import './TextStyles.css';
import XRegExp from 'xregexp';

class ProjectBlock extends Component {
    constructor(props) {
        super(props);
        const { id } = this.props;
        const initialShowingDetailsState = localStorage.getItem(id) || id === 'projectBlock-1' || "false";
        this.state = { isShowingDetails: JSON.parse(initialShowingDetailsState) };
        
    }
    
    onDisclosureClicked() {
        const newShowingDetailsState = !this.state.isShowingDetails;
        const { id } = this.props;

        localStorage.setItem(id, JSON.stringify(newShowingDetailsState));
        this.setState(
            {
                isShowingDetails: newShowingDetailsState
            }
        )
    }

    render() {
        const {
            id,
            showDivider,
            markdown,
            backgroundColor
        } = this.props;
        const detailsStyle = {
            marginTop: '1em',
            marginBottom: '1em'
        };
        const regex = new XRegExp('<!-- metadata(.*)-->', 'sm');
        const metaDataMatch = markdown.match(regex);
        const noCommentsMarkdown = markdown.replace(metaDataMatch[0], '')
        let labelValues = {};
        if (metaDataMatch) {
            const metaData = metaDataMatch[1];
            metaData.split('\n').forEach(element => {
                const [label, value] = element.split(':');
                if (label && value) {
                    labelValues[label.trim()] = value.trim();
                }
            });
        }
        const detailViewId = `project-detail-${id.replace(/[^0-9a-zA-Z]/g, '_')}}`;
        
        const details = this.state.isShowingDetails === true ?
            (
                <Markdown source={noCommentsMarkdown} />
            ) : undefined;

        const disclosureAngleDirection = this.state.isShowingDetails === true ? 'angle-down' : 'angle-up';
        const dividerElement = showDivider !== false ? ( <hr /> ) : undefined;
        return (
            <div style={{ backgroundColor }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span className='topicItemHeaderText'>{labelValues['title'] || 'no title'} </span>
                    <FontAwesome onClick={this.onDisclosureClicked.bind(this)} name={disclosureAngleDirection} className='DisclosureArrow' />
                </div>
                <div id={detailViewId} style={detailsStyle}>
                    { details }
                </div>
                { dividerElement }
            </div>
        );
    }
}

export default ProjectBlock;



// WEBPACK FOOTER //
// ./src/ProjectBlock.js